// import VanillaScrollspy from 'vanillajs-scrollspy'
// const scrollspy = new VanillaScrollspy(navigation, 800, 'easeInOutQuint')
// scrollspy.init()
import MoveTo from 'moveTo'
import { gsap } from 'gsap'

export default {
  init() {
    const { body, documentElement } = document

    const navigation = body.querySelector('.navigation')
    const breadcrumb = body.querySelector('.breadcrumbs')
    const hamburger = body.querySelector('.hamburger-menu')
    const languageSwitch = body.querySelector('.language-switch-mobile select')

    languageSwitch.addEventListener('change', (event) => {
      const index = event.target.options.selectedIndex
      const { url } = event.target.options[index].dataset
      window.location.replace(url)
    })

    hamburger.addEventListener('click', (e) => {
      e.preventDefault()
      documentElement.classList.toggle('open-menu')
    })

    if (navigation) {
      const moveTo = new MoveTo({
        tolerance: 133,
        duration: 800,
      })

      const triggers = document.querySelectorAll('.navigation a')
      for (let i = 0; i < triggers.length; i++) {
        moveTo.registerTrigger(triggers[i])
      }

      const sections = document.querySelectorAll('.main-content section')
      const menuLinks = document.querySelectorAll('.navigation a')

      // const makeActive = function makeActive(link) {
      //   return menuLinks[link] ? menuLinks[link].classList.add('active') : false
      // }

      const makeActive = (link) =>
        menuLinks[link] ? menuLinks[link].classList.add('active') : false
      const removeActive = (link) => menuLinks[link].classList.remove('active')
      const removeAllActive = () =>
        [...Array(sections.length).keys()].forEach((link) => removeActive(link))
      const sectionMargin = 0

      let currentActive = 0

      window.addEventListener('scroll', () => {
        const current =
          sections.length -
          [...sections]
            .reverse()
            .findIndex(
              (section) => window.scrollY >= section.offsetTop - sectionMargin
            ) -
          1

        if (current !== currentActive) {
          removeAllActive()
          currentActive = current
          makeActive(current)
        }
      })

      new Waypoint({
        element: navigation,
        handler() {
          this.element.classList.toggle('is-sticky')
        },
        offset: 80,
      })
    }

    const pageAboutChild = document.querySelector('.parent-about-us')
    const pageResearchChild = document.querySelector(
      '.parent-research-and-development'
    )
    const pageProductsChild = document.querySelector(
      '.parent-industrial-products-and-services'
    )

    if (pageAboutChild || pageResearchChild || pageProductsChild) {
      const moveTo = new MoveTo()
      setTimeout(() => {
        moveTo.move(breadcrumb, {
          tolerance: 80,
          duration: 800,
        })
      }, 400)
      new Waypoint({
        element: breadcrumb,
        handler() {
          this.element.classList.toggle('is-sticky')
        },
        offset: 80,
      })
    }

    const accordions = document.querySelectorAll('.accordion-item')

    if (accordions) {
      accordions.forEach((element) => {
        const accordionTitle = element.querySelector('a')

        const body = element.querySelector('.accordion-body')

        if (element.classList.contains('is-active')) {
          gsap.to(body, 0.2, {
            height: body.scrollHeight,
          })
        }

        accordionTitle.addEventListener('click', (event) => {
          event.preventDefault()
          element.classList.toggle('is-active')

          if (element.classList.contains('is-active')) {
            gsap.to(body, 0.2, {
              height: body.scrollHeight,
            })
          } else {
            gsap.to(body, 0.1, {
              height: 0,
            })
          }
        })
      })
    }

    window.onscroll = () => {
      // if (body.classList.contains('contact-us')) return
      const header = document.querySelector('.site-header')
      if (window.scrollY > 1) {
        header.classList.add('is-sticky')
      } else {
        header.classList.remove('is-sticky')
      }
    }
  },
  finalize() {
    // window.onload = () => {
    //   const pdpa = document.querySelector('.pdpa-consent')
    //   if (pdpa) {
    //     gsap.to(pdpa, 0.3, {
    //       height: pdpa.querySelector('.section').scrollHeight,
    //     })
    //   }
    // }
  },
}
